import { $, $$ } from 'utils/dom';
import { isImageLoaded } from 'utils/helper';
import Filter from 'modules/Filter/filter';

const mediaLib = $('.media-lib');
if (mediaLib) {
  if (
    $('.o-filter select', mediaLib) ||
    $('.o-filter__button', mediaLib) ||
    $('.media-lib__btn', mediaLib)
  ) {
    new Filter({
      container: mediaLib,
      filter: $('.o-filter', mediaLib),
      items: $$('.media-lib__fig', mediaLib),
      hiddenClass: 'media-lib__fig--hidden',
      activeClass: 'media-lib__fig--active',
      itemLinkClassName: 'a', // optional: only for a-tags, so hidden items cant be focused via keyboard
      loadMoreNode: $('.media-lib__btn', mediaLib), // optional: only if you have a load-more button
      defaultItemsToShow: 3, // optional: only needed if you are using load-more button
      amountOfItemsToShow: 4, // optional: only needed if you are using load-more button
    }).init();
  }
}

class ShiftImages {
  constructor(container) {
    this.container = container;
    this.images = $$('img', this.container);
  }

  setPictureClassesAndShift() {
    this.images.forEach(image => {
      isImageLoaded(image).then(response => {
        if (response.status === 'ok') {
          if (image.width > image.height) {
            image.parentNode.classList.add('is-landscape');

            const shiftAblePixels = Math.floor(
              this.container.offsetHeight - image.height
            );
            const pixelArray = [];
            for (let i = 1; i <= shiftAblePixels; i++) {
              if (i % 2 === 0) {
                pixelArray.push(i);
              }
            }
            const randomNumber =
              pixelArray[Math.floor(Math.random() * pixelArray.length)];

            image.parentNode.style.marginTop = randomNumber + 'px';
          } else {
            image.parentNode.classList.add('is-portrait');

            const shiftAblePercentage = Math.floor(
              100 - (image.width / this.container.offsetWidth) * 100
            );
            const percentageArray = [];
            for (let i = 1; i <= shiftAblePercentage; i++) {
              if (i % 2 === 0) {
                percentageArray.push(i);
              }
            }
            const randomNumber =
              percentageArray[
                Math.floor(Math.random() * percentageArray.length)
              ];

            image.parentNode.style.marginLeft = randomNumber + '%';
          }
        }
      });
    });
  }

  init() {
    this.setPictureClassesAndShift();
  }
}

const galleryItems = $$('.media-lib__gallery');

if (galleryItems.length) {
  galleryItems.forEach(item => {
    new ShiftImages(item).init();
  });
}
